<div class="root-container">
  <div class="content">
    <div class="img-container">
      <img src="assets/videos/robot.gif" alt="robot" />
    </div>

    <div class="code title-text">404</div>

    <div class="text-container">
      <h1 class="title-text">Page not found</h1>
      <a href="/">Back to home</a>
    </div>
  </div>
</div>
